






























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import AuthStoreModule from '@revas/kadra-library/src/core/auth/vue/vuex/AuthStoreModule'
import CoreStoreModule, { ChangeActiveOrganizationPayload } from '@revas/kadra-library/src/revas/vue/vuex/CoreStoreModule'
import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'
import OrganizationNavigator from '@revas/kadra-library/src/revas/vue/vue-router/OrganizationNavigator'
import VueI18n from 'vue-i18n'

import { ChangeEvent, ChromeLayout, PageLayout, ContainerLayout, LinearLayout, BaseHeading, BaseField, BaseInput, ScrollLayout, BaseModal, BaseAvatarBlock, BaseTabs, BaseAvatar, BaseIcon, BaseButton } from '@revas/reef'

import AppError from '@revas/kadra-library/src/core/app/vue/vuex/AppError'

import Organization from '@revas/kadra-library/src/revas/vue/vuex/models/Organization'
import User from '@revas/kadra-library/src/revas/vue/vuex/models/User'

import AppFavoriteAppsTabs from '../components/shared/AppFavoriteAppsTabs.vue'

import { SystemInfo, App } from '../models'

@Component({
  components: {
    ChromeLayout,
    ContainerLayout,
    PageLayout,
    LinearLayout,
    ScrollLayout,
    BaseModal,
    BaseField,
    BaseInput,
    BaseAvatarBlock,
    BaseHeading,
    BaseTabs,
    BaseAvatar,
    BaseIcon,
    BaseButton,
    AppFavoriteAppsTabs
  }
})
export default class OrganizationLayout extends Vue {
  @Prop() authStoreModule!: AuthStoreModule
  @Prop() coreStoreModule!: CoreStoreModule
  @Prop() appStoreModule!: AppStoreModule
  @Prop() organizationId!: string
  @Prop() navigator!: OrganizationNavigator
  @Prop() i18n!: VueI18n
  @Prop() baseUrl!: string
  @Prop() systemInfo!: SystemInfo

  get organization (): Organization {
    const o = this.coreStoreModule.activeUserOrganization
    return o === null ? new Organization() : o
  }

  get user (): User {
    const u = this.coreStoreModule.userProfile
    return u === null ? new User() : u
  }

  @Watch('organizationId', { immediate: true })
  async onRouteUpdate (value: string | undefined) {
    console.log('systemInfo', this.systemInfo)
    if (value === undefined) {
      return
    }
    if (value === '-') {
      this.navigator.changeOrganization('-')
      return
    }
    const payload = new ChangeActiveOrganizationPayload()
    payload.organizationId = value
    this.coreStoreModule.asyncChangeActiveOrganization(payload)
    await this.coreStoreModule.asyncListFavoriteApps({})
  }

  onAppTabChange ($event: ChangeEvent<App>) {
    if ($event.value !== null) {
      window.location.href = $event.value.url
    }
  }

  get favoriteApps (): App[] {
    return this.coreStoreModule.currentFavoriteApps
  }

  onOrganizationSelected (event: ChangeEvent<Organization>) {
    if (event.value === null) {
      const errorPayload = new AppError()
      this.appStoreModule.asyncPushError(errorPayload)
      return
    }
    this.navigator.changeOrganization(event.value.id)
  }

  //
  //
  // Organization Selection
  get organizations () {
    const o = this.coreStoreModule.userOrganizations
    if (o !== null) {
      return o
    } else {
      return []
    }
  }

  private showSelect = false

  private search = ''
  get filteredOrganizations () {
    if (this.search === '') {
      return this.organizations
    }
    return this.organizations.filter((o) => {
      return o.name.toLowerCase().includes(this.search.toLowerCase())
    })
  }

  async changeOrganization (organization: Organization) {
    this.navigator.changeOrganization(organization.id)
    this.showSelect = false
  }

  //
  //
  // Create organization
  createOrganization () {
    window.location.href = '/organizations/?create=true'
  }

  //
  //
  // Chrome Left Bar
  private isShowingSupportTooltip = false

  showSupportTooltip () {
    this.isShowingSupportTooltip = !this.isShowingSupportTooltip
  }

  private isShowingGuidesTooltip = false

  showGuidesTooltip () {
    this.isShowingGuidesTooltip = !this.isShowingGuidesTooltip
  }
}
